export default "__VITE_ASSET__Astq7cCr__"